import React from "react";
import { Modal } from "react-bootstrap";

export default class Contact extends React.Component {
  constructor(props) {
    super(props);
    this.handleClose = this.handleClose.bind(this);
    this.state = {
      show: false,
    };
  }

  componentDidMount() {
    window.addEventListener("hashchange", () => {
      if (document.location.href.includes("message=thankyou")) {
        this.setState({ show: true });
      }
    });
  }

  handleClose() {
    this.setState({ show: false });
    window.location.href = "/";
  }

  render() {
    return (
      <div className="footer section translucent-bg bg-image-4 pb-clear">
        <footer id="footer">
          <div className="container-fluid" style={{ marginTop: "4.5%" }}>
            <h1
              id="contact"
              className="title text-center"
              style={{ marginTop: "4.5%" }}
            >
              <span>Contact Us</span>
            </h1>
            <div className="space" />
            <div className="row">
              <div className="col-md-6 col-lg-6">
                <div className="footer-content">
                  <p className="large">You can contact us at:</p>
                  <ul className="list-icons">
                    <li>
                      <i className="glyphicon glyphicon-map-marker pr-10" />{" "}
                      <b>NicheSolv</b>
                    </li>
                    <li>
                      129, 3rd Floor, 8th Main, J P Nagar 3rd Phase, Bangalore
                      560078
                    </li>
                    <li>Karnataka, India</li>
                    <li>
                      <b>Jobs: </b>
                    </li>
                    <li>
                      <i className="glyphicon glyphicon-envelope pr-10" />
                      <b> Email: resumes@nichesolv.com</b>
                    </li>
                    <li>
                      <i className="glyphicon glyphicon-phone pr-10" />{" "}
                      <b>India:</b> (91) 8431084965
                    </li>
                    <li>
                      <b>Sales: </b>
                    </li>
                    <li>
                      <i className="glyphicon glyphicon-envelope pr-10" />
                      <b> Email: sales@nichesolv.com</b>
                    </li>
                    <li>
                      <i className="glyphicon glyphicon-phone pr-10" />{" "}
                      <b>India:</b> (91) 9902985015
                    </li>
                    <hr />
                    <li>
                      <i className="glyphicon glyphicon-phone pr-10" />{" "}
                      <b>USA:</b> +1(347) 651 9100
                    </li>
                    <li>
                      <i className="glyphicon glyphicon-map-marker pr-10" />{" "}
                      6732 Positano Lane, San Jose, CA 95138
                    </li>
                  </ul>
                </div>
                <br />
                <br />
                <br />
              </div>
              <div className="col-md-6 col-lg-6">
                <div className="footer-content">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d972.2285868847288!2d77.5946339291765!3d12.913226406618822!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae159a3c327d67%3A0x569a2c7dae7ba63a!2sNicheSoft!5e0!3m2!1sen!2sin!4v1559718071108!5m2!1sen!2sin"
                    width="100%"
                    height="150%"
                    frameBorder={0}
                    style={{
                      border: 0,
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="zohoBeginFormLayout">
              <iframe
                id="zohoBigin"
                className="zohoBeginForm"
                src="https://crm.zohopublic.in/crm/WebFormServeServlet?rid=62c7ea34290e973cdf74c83fc993b4068fe876e5406ced904cefdfc8892a668egidf4accba967bb60aaadcbc35e7a6b6b01d21cfff687a1f5954518374f34aecc28"
              ></iframe>
            </div>
            <Modal
              id="modalPopup"
              show={this.state.show}
              onHide={this.handleClose}
              aria-labelledby="contained-modal-title-lg"
            >
              <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-lg">
                  Thank you
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="row">
                  <p className="text-center">Thank you for your interest!</p>
                </div>
              </Modal.Body>
            </Modal>
          </div>
        </footer>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// /home/reetika/Desktop/nichesolvweb/website/nswebsite/src/containers/contact_us.js